import parse from 'url-parse';

const LOCAL_HOSTNAME = 'localhost';
const DEV_HOSTNAME = 'drillx-so-front-d.drillx.iasp.tgscloud.net';
// TODO: ESK-511 - remove this hostname

const IN_DEVELOPMENT_HOSTNAMES = [LOCAL_HOSTNAME, DEV_HOSTNAME];

const urlData = parse(window.location.href, true);

const shouldShowInDevelopmentFeature = () => IN_DEVELOPMENT_HOSTNAMES.includes(urlData.hostname);

export const useIsDev = () => {
  const r = shouldShowInDevelopmentFeature();

  return r;
};
